module.exports = __webpack_public_path__ + "60c80cdfc42438c0618f88682097af08.svg";